import React, {ReactNode} from 'react'
import clsx from 'clsx'
import {TranslationObject} from '@colonist/i18n'
import {ImageURL} from '@colonist/types'
import {T} from '../T/T'
import styles from './UIGameActionBoxBase.module.scss'
import IconCheck from '@static/images/icon_check.svg'
import IconX from '@static/images/icon_x.svg'
import BgButton from '@static/images/bg_button.svg'

export interface UIGameActionBoxBaseProps {
    isVisible?: boolean
    isConfirmDisabled?: boolean
    onClose?: () => void
    onConfirm: () => void
    title: TranslationObject
    body: TranslationObject
    imagePath: ImageURL
    children?: ReactNode
    className?: string
    footerContent?: ReactNode
    titleClassName?: string
    isPortrait?: boolean
}

export const UIGameActionBoxBase = ({
    isVisible = true,
    isConfirmDisabled,
    onClose,
    onConfirm,
    title,
    body,
    imagePath,
    children,
    className,
    footerContent,
    titleClassName,
}: UIGameActionBoxBaseProps) => {
    if(!isVisible) return null

    const confirmationButtons = (
        <>
            {onClose && (
                <div
                    className={styles.closeButton}
                    onClick={onClose}
                >
                    <img
                        className={styles.buttonBackground}
                        draggable={false}
                        src={BgButton}
                    />
                    <img
                        className={styles.buttonIcon}
                        draggable={false}
                        src={IconX}
                    />
                </div>
            )}

            <div
                className={clsx(styles.confirmButton, {
                    [styles.faded]: isConfirmDisabled,
                })}
                onClick={isConfirmDisabled ? undefined : onConfirm}
            >
                <img
                    className={styles.buttonBackground}
                    draggable={false}
                    src={BgButton}
                />
                <img
                    className={styles.buttonIcon}
                    draggable={false}
                    src={IconCheck}
                />
            </div>
        </>
    )

    const hasFooterContent = footerContent != undefined
    const hasBodyContent = children != undefined
    const showButtonsInHeader = !hasFooterContent && !hasBodyContent

    return (
        <div className={clsx(styles.actionBox, className)} >
            <div className={styles.header}>
                <img className={styles.headerImage} src={imagePath} />
                <div>
                    <div className={clsx(styles.title, titleClassName)}>
                        <T id={title} />
                    </div>
                    <p className={styles.body}>
                        <T id={body} />
                    </p>
                </div>
                {showButtonsInHeader && (
                    <div className={styles.headerConfirmationButtons}>
                        {confirmationButtons}
                    </div>
                )}
            </div>

            {children != undefined && (
                <div className={styles.interactiveBody}>
                    {!hasFooterContent && (
                        <div className={styles.bodyConfirmationButtons}>
                            {confirmationButtons}
                        </div>
                    )}
                    {children}
                </div>
            )}

            {hasFooterContent && (
                <div className={styles.footer}>
                    {footerContent}
                    <div className={styles.footerConfirmationButtons}>
                        {confirmationButtons}
                    </div>
                </div>
            )}
        </div>
    )
}
